'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * Field description component, used to provide additional information below the input.
 *
 * @example
 * <FieldDescription>Additional information</FieldDescription>
 */
const FieldDescription = forwardRef(function FieldDescription(rest, ref) {
    return jsx("div", { "data-field": 'description', ref: ref, ...rest });
});

export { FieldDescription };
